import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/app-config';
import { JsLoaderService } from 'src/shared/services/js-loader.service';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html'
})
export class UserGuideComponent implements OnInit {

  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }

  covidUserGuide = this.config.covidUserGuide;
  drugScreeningUserGuide = this.config.DrugScreeningUserGuide;
  immunizationGuide = this.config.ImmuniationUserGuide;


  ConfidentialitySOPGuide = this.config.ConfidentialitySOPURL;
  UserRecordAccessNotification = this.config.UserRecordAccessURL;

  ngOnInit() {
    this.jsLoader.loadScripts();
  }
}
